import { Theme } from '@mui/material';

export const taskOverviewColors = (theme: Theme) => [
  {
    color: theme.palette.taskboard.lightPurple,
    typographyColor: theme.palette.success.darker,
  },
  {
    color: theme.palette.primary.main,
    typographyColor: theme.palette.quaternary.dark,
  },
  {
    color: theme.palette.info.darker,
    typographyColor: theme.palette.info.darker,
  },
  {
    color: theme.palette.taskboard.celery,
    typographyColor: theme.palette.quaternary.dark,
  },
  {
    color: theme.palette.quaternary.main,
    typographyColor: theme.palette.success.darker,
  },
  {
    color: theme.palette.secondary.light,
    typographyColor: theme.palette.success.darker,
  },
  {
    color: theme.palette.quaternary.darkBlue,
    typographyColor: theme.palette.quaternary.dark,
  },
  {
    color: theme.palette.quaternary.customTurquoise,
    typographyColor: theme.palette.quaternary.customTurquoise,
  },
  {
    color: theme.palette.quaternary.royalBlue,
    typographyColor: theme.palette.quaternary.royalBlue,
  },
  {
    color: theme.palette.taskboard.carissma,
    typographyColor: theme.palette.taskboard.carissma,
  },
  {
    color: theme.palette.quaternary.lighter,
    typographyColor: theme.palette.quaternary.lighter,
  },
];
